export const CADI_CONFIG_PREVIOUS_CACHE_NAME = 'cadiConfig';
export const CADI_CONFIG_CACHE_NAME = 'cadiConfigV2';
export const NOT_STARTED_MANAGER_ERROR_MESSAGE =
  '`AppConfigManager.load` must be called first to initialize the configurations.';
export const FAILED_LOAD_CONFIGS_ERROR_MESSAGE = 'Failed to load configurations';
